h1,
h2,
h3,
h4,
h5,
h6 {
  margin: 0;
  color: var(--lgr-color-neutral-low-pure);
  font-family: var(--lgr-font-family-bold);
  text-overflow: inherit;
  white-space: inherit;
  overflow: inherit;
}

h1 {
  font-size: var(--lgr-font-size-xxl);
}

h2 {
  font-size: var(--lgr-font-size-xl);
}

h3 {
  font-size: var(--lgr-font-size-lg);
}

h4 {
  font-size: var(--lgr-font-size-md);
}

h5 {
  font-size: var(--lgr-font-size-sm);
}

h6 {
  font-size: var(--lgr-font-size-xs);
}

.inverse {
  color: var(--lgr-color-neutral-high-pure);
}

.dark {
  color: var(--lgr-color-neutral-low-dark);
}
